var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"value":_vm.isChecked,"labels":true,"sync":true},on:{"change":function($event){return _vm.toggleCreative($event, _vm.url_token)}}})}
var staticRenderFns = []

export { render, staticRenderFns }